import { Box, Typography } from "@mui/material";

import PageContainer from "../shared/PageContainer";

const NotFound: React.FC = () => {
  return (
    <PageContainer>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="200px"
        textAlign="center"
      >
        <Typography variant="h2" component="h1" gutterBottom>
          😕 Not found
        </Typography>
        <Typography variant="h5">The page you’re trying to find doesn’t exist.</Typography>
      </Box>
    </PageContainer>
  );
};
export default NotFound;
